import * as Select from '@cleartax/wg-library-select';
import { throttle } from 'lodash';
import { useState } from 'react';
import { cmsAxios } from '../../../http-common';

export const Search = ({
  domainVal = 1,
}: {
  domainVal?: number;
}): JSX.Element => {
  const [searchDrop, setSearchDrop] = useState([]);
  const [searchKey, setSearchKey] = useState('');

  const handleOnChange = async (value: string) => {
    setSearchKey(value);
    try {
      const response = cmsAxios.get(
        `/f/content_management/post/get_all_permalinks/?domain=${domainVal}&status=publish&content_type=glossary&title=${value}`
      );
      const { data } = await response;

      const result = data?.map((item: { permalink: string; title: string }) => {
        return { value: item['permalink'], label: item['title'] };
      });
      setSearchDrop(result || []);
    } catch (e) {
      console.error('API failure', e);
      setSearchDrop([]);
    }
  };

  return (
    <div className="sm:my-4 z-10 mt-10 mb-6 sticky top-[80px] sm:top-[50px]">
      <Select.SelectContainer
        className="max-w-3xl mx-auto relative"
        options={searchDrop}
        onChange={throttle(handleOnChange, 1000)}
        value={searchKey}
        data-testid="select-container"
        disableOptionFiltering={true}
      >
        <Select.SelectInput
          inputSuffix={
            <img
              className="w-7 h-7"
              alt="search-icon"
              src="https://assets.clear.in/cleartax/images/1695727993_search.png"
            />
          }
          placeholder={'Search for a word'}
        />
        <Select.SelectOptions
          overrideListClasses={{
            containerClasses: 'absolute z-20 w-full bg-white',
          }}
          renderCustomElement={(option) => (
            <a
              className="inline-block text-grey-970 leading-6 w-full"
              href={`/glossary/${option.value}`}
            >
              {option.label}
            </a>
          )}
        />
      </Select.SelectContainer>
    </div>
  );
};
